@if (basdata && searchFilter) {
  <rask-arbetsorder-search-filter [title]="texts.filters.skogligData" (toggleVisibility)="toggleShow()"
    [visible]="isVisible" [hasValues]="isDirty()" aid="filterSkogligData">
    <div class="row">
      <div class="col-12 ps-0 pb-3">
        <rask-radiobutton-group [buttons]="radioButtonsArbetsorderAtgard.entity"
          (change)="setSearchArbetsorderOrAtgarder($event)"
          [label]="texts.uppdelning"
          [ngModel]="getSearchArbetsorderOrAtgarder()"
          aid="filterSkogligDataUppdelning">
        </rask-radiobutton-group>
      </div>
    </div>
    <div class="row">
      <div class="col-12 ps-0 pe-0 ms-0 me-0 pt-3">
        <div class="component-block float-start ps-0 m-0">
          <rask-header size="4" class="component-header">{{texts.tillganglighet}}</rask-header>
          <rask-arbetsorder-search-skoglig-data-tillganglighet [searchFilter]="searchFilter"
          [basdata]="basdata"></rask-arbetsorder-search-skoglig-data-tillganglighet>
        </div>
        <div class="component-block productgroup-block col-4 p-0 m-0">
          <rask-header size="4" class="component-header">{{texts.produktgrupper}}</rask-header>
          <rask-arbetsorder-search-skoglig-data-produktgrupper [searchFilter]="searchFilter"
          [basdata]="basdata"></rask-arbetsorder-search-skoglig-data-produktgrupper>
        </div>
        <div class="component-block p-0 m-0">
          <rask-header size="4" class="component-header">{{texts.medelstamm3fub}}</rask-header>
          <div class="medelstam-container">
            <rask-input-number aid="filterSkogligDataMedelstamMin" [label]="texts.medelstamMin" [min]="0"
              [max]="medelstamMax" [step]="0.01" class="m3fub-input pe-1"
            [(ngModel)]="medelstamMin"></rask-input-number>
            <rask-input-number aid="filterSkogligDataMedelstamMax" [label]="texts.medelstamMax"
              [min]="medelstamMaxMinRule" [step]="0.01" class="m3fub-input ps-1"
            [(ngModel)]="medelstamMax"></rask-input-number>
          </div>
          @if (searchFilter.skogligdata.searchOnArbetsorder) {
            <div class="col ps-0 pt-3 component-block">
              <rask-header size="4" class="component-header">{{texts.skotningAvstand}}</rask-header>
              <rask-arbetsorder-search-skoglig-data-skotning-avstand [searchFilter]="searchFilter">
              </rask-arbetsorder-search-skoglig-data-skotning-avstand>
            </div>
          }
        </div>
        <div class="component-block">
          <rask-header size="4" class="component-header">{{texts.grot}}</rask-header>
          <rask-checkbox [text]="texts.showgrotanpassatrv"
            [ngModel]="hasCheckedValue(searchFilter.grot.grotanpassad)"
            (change)="searchFilter.grot.grotanpassad = $event"
          aid="filterSkogligDataShowgrotanpassatrv"></rask-checkbox>
        </div>
        @if (searchFilter.skogligdata.searchOnArbetsorder) {
          <div
            class="component-block">
            <rask-header size="4" class="component-header">{{texts.tradslag}}</rask-header>
            <rask-arbetsorder-search-skoglig-data-tradslag
            [searchFilter]="searchFilter"></rask-arbetsorder-search-skoglig-data-tradslag>
          </div>
        }
      </div>
    </div>
    @if (!searchFilter.skogligdata.searchOnArbetsorder) {
      <div class="row">
        <rask-header size="4" class="component-header">{{texts.byl}}</rask-header>
        <rask-byl [searchFilter]="searchFilter"></rask-byl>
      </div>
    }
  </rask-arbetsorder-search-filter>
}